import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'

import authSlice from './slices/auth'
import pincodeSlice from './slices/pincode'
import productCatergoySlice from './slices/category'
import utmCampaignSlice from './slices/utm'
import cartSlice from './slices/cart'
import addressSlice from './slices/address';
const authPersistConfig = {
    key: 'auth',
    storage,
    blacklist: ['openLoginModal']
}

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['auth']
}

const rootReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authSlice),
    geoInof: pincodeSlice,
    productCategeory: productCatergoySlice,
    utm: utmCampaignSlice,
    cart: cartSlice,
    address:addressSlice

})

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer
})
export const persistor = persistStore(store)
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

